import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Applicants } from '../applicants/Applicants';
import { UrlSignature } from '../common/apiEndpoint';

@Injectable()
export class DashboardService {
  constructor(
    private httpClient: HttpClient,
    private urlSignature: UrlSignature,
  ) {}

  getTotalApplicants(): Observable<Applicants[]> {
    const url = this.urlSignature.totalApplicantCountUrl;
    return this.httpClient
      .get(url)
      .pipe(map((response) => response as Applicants[]));
  }

  getApplicants(programmeId: string): Observable<Applicants[]> {
    const url = this.urlSignature.applicantCountUrl + programmeId;
    return this.httpClient
      .get(url)
      .pipe(map((response) => response as Applicants[]));
  }
}
